import type { Primitives } from 'models'

export const resolveValueType = (value: unknown): Primitives => {
    if (Array.isArray(value)) {
        if (value.length && typeof value[0] !== 'object') {
            return value.join(', ')
        }
        return `${value.length}`
    }

    if (value === null) {
        return ''
    }

    return value as Primitives
}

export const resolveValueTypeToString = (value: unknown): string => {
    if (Array.isArray(value)) {
        if (value.length && typeof value[0] !== 'object') {
            return value.join(', ')
        }
        return `${value.length}`
    }

    if (value === null) {
        return ''
    }

    if (typeof value === 'string') {
        return value
    }

    // catch all for value
    return JSON.stringify(value)
}
